import React from 'react';
import { Outlet } from 'react-router';

export const DocumentPreviewSubLayout = () => {
  return (
    <div className="main-layout__withOutSidebar">
      <Outlet />
    </div>
  );
};
